export default {
  path: '/v5/matches',
  name: 'V5_matches',
  component: () => import('./MatchesPage.vue'),
};
